import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { formatNumber } from "../../../utils/utilityfunc";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import {
  TODAYS_DATE_FORMATTED,
  convertThenFormat,
  currentMonthName,
  currentMonthNumber,
  currentYear,
} from "../../../components/common-data/Converts";
import CommonFilterStructure from "../../../components/common-components/CommonFilterStructure";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { ctoStats } from "../../../data/ApiEndpoints";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import AgentwiseDailyTagrget from "../agents/AgentwiseDailyTagrget";

const DailyTarget = ({ user, gymFilterObj, prevAllFilters }) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isClusterManager = user?.account_type === "cluster_manager";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(user?.account_type);

  const iniTbDatas = {
    allData: [],
    sortedData: null,
    allStatsDta: {
      target_value: 0,
      target_value_acheived: 0,
      daily_target: 0,
    },
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniAllFilters = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.user_id || user?.uid || "",
          }
        : gymFilterObj
        ? gymFilterObj
        : "",
    selectedMonth: {
      label: currentMonthName,
      value: currentMonthNumber,
    },
    selectedYear: {
      label: currentYear,
      value: currentYear,
    },
    selecteRPType: "",
    selectedOtherUsers: isClusterManager
      ? {
          label: user?.name || "",
          value: user?.uid || user?.user_id || "",
        }
      : "",
    selAddedby: prevAllFilters?.selAddedby || "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniTbFilters = {
    gym_id: isManagerRole ? "" : allFilters.selectedGym?.value || "",
    month: allFilters.selectedMonth?.value || "",
    year: allFilters.selectedYear?.value || "",
    cluster_manager_id: allFilters.selAddedby?.value || "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);
  const [activeHeadKey, setActiveHeadKey] = useState(":");
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setTbFilters(iniTbFilters);
  };

  function sortedTableDataAccordingToKey(order, tableKey) {
    if (activeHeadKey === `${order}_${tableKey}`) {
      setActiveHeadKey(null);

      setTbDatas((prev) => ({
        ...prev,
        sortedData: null,
      }));

      return;
    }

    setActiveHeadKey(`${order}_${tableKey}`);

    let sortedData = [...tbDatas.allData];

    sortedData.sort((a, b) => {
      const valueA = parseFloat(a[tableKey]) || 0;
      const valueB = parseFloat(b[tableKey]) || 0;

      if (order === "high") {
        return valueB - valueA;
      } else {
        return valueA - valueB;
      }
    });

    setTbDatas((prev) => ({
      ...prev,
      sortedData: sortedData,
    }));
  }

  function getDailyTargetData(tbFilters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: ctoStats,
        payload: {
          filters: tbFilters,
        },
        token: user?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && !isManagerRole
          ? {
              label: isGym ? user?.name : user?.gym_name || "",
              value: user?.gym_id || user?.user_id || user?.uid || "",
            }
          : gymFilterObj
          ? gymFilterObj
          : "",
    }));
  }, [user?.gym_id]);

  useEffect(() => {
    setTbFilters((prevs) => ({
      ...prevs,
      gym_id: isManagerRole ? "" : allFilters.selectedGym?.value || "",
      month: allFilters.selectedMonth?.value || "",
      year: allFilters.selectedYear?.value || "",
      cluster_manager_id: allFilters.selAddedby?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedMonth,
    allFilters.selectedYear,
    allFilters.selAddedby,
  ]);

  useEffect(() => {
    if (tbFilters.month && tbFilters.year) {
      getDailyTargetData(tbFilters);
    }
  }, [tbFilters]);

  useEffect(() => {
    if (data?.status && !error && !loading) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: data?.data || [],
        allStatsDta: data?.stats || {},
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [data, error, loading]);

  useEffect(() => {
    if (allFilters.selecteRPType?.value) {
      const filterTypeValue = allFilters.selecteRPType?.value;
      const sendableFilterType =
        filterTypeValue === "pt"
          ? "deficit_pt"
          : filterTypeValue === "regular"
          ? "deficit_regular"
          : "deficit_total";

      sortedTableDataAccordingToKey("high", sendableFilterType);
    } else if (!allFilters.selecteRPType?.value && !activeHeadKey) {
      sortedTableDataAccordingToKey("low", "deficit_total");
    }
  }, [allFilters.selecteRPType]);

  useEffect(() => {
    if (prevAllFilters?.selAddedby) {
      setAllFilters((prevs) => ({
        ...prevs,
        selAddedby: prevAllFilters.selAddedby,
      }));
    }
  }, [prevAllFilters?.selAddedby]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 link"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "FD_targets",
                rowData: row,
              }))
            }
          >
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    allFilters.selecteRPType?.value !== "pt" &&
    allFilters.selecteRPType?.value !== "regular"
      ? {
          dataField: "target_value",
          text: "overall gym Target",
          formatter: (_, row) => {
            return (
              <span className="tb-data">
                ₹{convertThenFormat(row?.target_value) || 0}
              </span>
            );
          },
        }
      : "",
    allFilters.selecteRPType?.value !== "pt" &&
    allFilters.selecteRPType?.value !== "regular"
      ? {
          dataField: "target_acheived",
          text: (
            <div className="tb-head-row">
              <span>overall Target acheived</span>
              <span
                className={`head-icon ${
                  activeHeadKey === "high_target_acheived" ? "active" : ""
                }`}
                onClick={() =>
                  sortedTableDataAccordingToKey("high", "target_acheived")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-up-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                  />
                </svg>
              </span>
              <span
                className={`head-icon ${
                  activeHeadKey === "low_target_acheived" ? "active" : ""
                }`}
                onClick={() =>
                  sortedTableDataAccordingToKey("low", "target_acheived")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-down-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                  />
                </svg>
              </span>
            </div>
          ),
          formatter: (_, row) => {
            const isAbove = row?.target_value
              ? parseInt(row?.target_acheived) >= parseInt(row?.target_value)
              : true;
            const difference = row?.target_value
              ? parseInt(row?.target_acheived || 0) -
                parseInt(row?.target_value || 0)
              : null;

            return (
              <div
                className="emeberDetailsRowContainer column"
                style={{ gap: "0" }}
              >
                <span className="tb-data minWidth150">
                  ₹{convertThenFormat(row?.target_acheived) || 0}
                  {isAbove ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-up-short"
                      viewBox="0 0 16 16"
                      style={{ color: "#209216" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-down-short"
                      viewBox="0 0 16 16"
                      style={{ color: "#E41815" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                      />
                    </svg>
                  )}
                  <br />
                  <b
                    style={{
                      color: difference < 0 ? "#CD0909" : "#379C00",
                    }}
                  >
                    {row?.target_remaining < 0 ? "+" : "-"}
                    {convertThenFormat(row?.target_remaining || 0)}
                  </b>
                </span>
                <span
                  className="tb-data"
                  style={{
                    fontSize: "12px",
                    color:
                      parseFloat(row?.total_acheive_per || 0) <= 0
                        ? "#CD0909"
                        : "#379C00",
                  }}
                >
                  {parseFloat(row?.total_acheive_per || 0)?.toFixed()}%
                  Completed
                </span>
              </div>
            );
          },
        }
      : "",
    allFilters.selecteRPType?.value !== "pt" &&
    allFilters.selecteRPType?.value !== "overall"
      ? {
          dataField: "regular_target",
          text: "Regular Target",
          formatter: (_, row) => {
            return (
              <span className="tb-data">
                ₹{convertThenFormat(row?.regular_target) || 0}
              </span>
            );
          },
        }
      : "",
    allFilters.selecteRPType?.value !== "pt" &&
    allFilters.selecteRPType?.value !== "overall"
      ? {
          dataField: "regular_acheived",
          text: (
            <div className="tb-head-row">
              <span>Regular Target acheived</span>
              <span
                className={`head-icon ${
                  activeHeadKey === "high_regular_acheived" ? "active" : ""
                }`}
                onClick={() =>
                  sortedTableDataAccordingToKey("high", "regular_acheived")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-up-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                  />
                </svg>
              </span>
              <span
                className={`head-icon ${
                  activeHeadKey === "low_target_acheived" ? "active" : ""
                }`}
                onClick={() =>
                  sortedTableDataAccordingToKey("low", "regular_acheived")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-down-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                  />
                </svg>
              </span>
            </div>
          ),
          formatter: (_, row) => {
            const isAbove = row?.regular_target
              ? parseInt(row?.regular_acheived) >= parseInt(row?.regular_target)
              : true;
            const differenceRegular = row?.regular_target
              ? parseInt(row?.regular_acheived || 0) -
                parseInt(row?.regular_target || 0)
              : 0;

            return (
              <div
                className="emeberDetailsRowContainer column"
                style={{ gap: "0" }}
              >
                <span className="tb-data minWidth150">
                  ₹{convertThenFormat(row?.regular_acheived) || 0}
                  {isAbove ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-up-short"
                      viewBox="0 0 16 16"
                      style={{ color: "#209216" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-down-short"
                      viewBox="0 0 16 16"
                      style={{ color: "#E41815" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                      />
                    </svg>
                  )}
                  <br />
                  <small
                    style={{
                      color: differenceRegular < 0 ? "#CD0909" : "#379C00",
                    }}
                  >
                    {differenceRegular > 0 ? "+" : null}{" "}
                    {convertThenFormat(differenceRegular || 0)}
                  </small>
                </span>
                <span
                  className="tb-data"
                  style={{
                    fontSize: "12px",
                    color:
                      parseFloat(row?.regular_acheive_per || 0) <= 0
                        ? "#CD0909"
                        : "#379C00",
                  }}
                >
                  {parseFloat(row?.regular_acheive_per || 0)?.toFixed()}%
                  Completed
                </span>
              </div>
            );
          },
        }
      : "",
    allFilters.selecteRPType?.value !== "regular" &&
    allFilters.selecteRPType?.value !== "overall"
      ? {
          dataField: "pt_target",
          text: "PT Target",
          formatter: (_, row) => {
            return (
              <span className="tb-data">
                ₹{convertThenFormat(row?.pt_target) || 0}
              </span>
            );
          },
        }
      : "",
    allFilters.selecteRPType?.value !== "regular" &&
    allFilters.selecteRPType?.value !== "overall"
      ? {
          dataField: "addon_pt_acheived",
          text: (
            <div className="tb-head-row">
              <span>PT Target acheived</span>
              <span
                className={`head-icon ${
                  activeHeadKey === "high_addon_pt_acheived" ? "active" : ""
                }`}
                onClick={() =>
                  sortedTableDataAccordingToKey("high", "addon_pt_acheived")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-up-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                  />
                </svg>
              </span>
              <span
                className={`head-icon ${
                  activeHeadKey === "low_addon_pt_acheived" ? "active" : ""
                }`}
                onClick={() =>
                  sortedTableDataAccordingToKey("low", "addon_pt_acheived")
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-down-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                  />
                </svg>
              </span>
            </div>
          ),
          formatter: (_, row) => {
            const isAbove = row?.pt_target
              ? parseInt(row?.addon_pt_acheived) >= parseInt(row?.pt_target)
              : true;
            const differenceRegular = row?.pt_target
              ? parseInt(row?.addon_pt_acheived || 0) -
                parseInt(row?.pt_target || 0)
              : 0;

            return (
              <div
                className="emeberDetailsRowContainer column"
                style={{ gap: "0" }}
              >
                <span className="tb-data minWidth150">
                  ₹{convertThenFormat(row?.addon_pt_acheived) || 0}
                  {isAbove ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-up-short"
                      viewBox="0 0 16 16"
                      style={{ color: "#209216" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-down-short"
                      viewBox="0 0 16 16"
                      style={{ color: "#E41815" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                      />
                    </svg>
                  )}
                  <br />
                  <small
                    style={{
                      color: differenceRegular < 0 ? "#CD0909" : "#379C00",
                    }}
                  >
                    {differenceRegular > 0 ? "+" : null}{" "}
                    {convertThenFormat(differenceRegular || 0)}
                  </small>
                </span>
                <span
                  className="tb-data"
                  style={{
                    fontSize: "12px",
                    color:
                      parseFloat(row?.pt_acheive_per || 0) <= 0
                        ? "#CD0909"
                        : "#379C00",
                  }}
                >
                  {parseFloat(row?.pt_acheive_per || 0)?.toFixed()}% Completed
                </span>
              </div>
            );
          },
        }
      : "",
    {
      dataField: "ideal_target_as_today_total",
      text: (
        <div className="tb-head-row">
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0px",
            }}
          >
            <span>
              Ideal {allFilters.selecteRPType?.label || ""} Target To acheive as
              on today
            </span>
            <small>{TODAYS_DATE_FORMATTED}</small>
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "high_ideal_target_as_today_total" ||
              activeHeadKey === "high_ideal_target_as_today_pt" ||
              activeHeadKey === "high_ideal_target_as_today_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "high",
                allFilters.selecteRPType?.value === "pt"
                  ? "ideal_target_as_today_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "ideal_target_as_today_regular"
                  : "ideal_target_as_today_total"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-up-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
              />
            </svg>
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "low_ideal_target_as_today_total" ||
              activeHeadKey === "low_ideal_target_as_today_pt" ||
              activeHeadKey === "low_ideal_target_as_today_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "low",
                allFilters.selecteRPType?.value === "pt"
                  ? "ideal_target_as_today_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "ideal_target_as_today_regular"
                  : "ideal_target_as_today_total"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-down-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
              />
            </svg>
          </span>
        </div>
      ),
      formatter: (_, row) => {
        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0",
            }}
          >
            <span
              className="tb-data"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                rowGap: "7px",
              }}
            >
              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "regular" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "overall"
                    ? "Overall:"
                    : null}{" "}
                  <b style={{ color: "rgb(205, 9, 9)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.ideal_target_as_today_total || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "regular"
                    ? "Regular:"
                    : null}{" "}
                  <b style={{ color: "rgb(0, 178, 149)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.ideal_target_as_today_regular || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "regular" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "pt"
                    ? "PT:"
                    : null}{" "}
                  <b style={{ color: "rgb(6, 108, 227)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.ideal_target_as_today_pt || 0)}
                  </b>
                </small>
              ) : null}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "ideal_target_total",
      text: (
        <div className="tb-head-row">
          <span>
            {`ideal Daily ${allFilters.selecteRPType?.label || ""} Target`}
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "high_ideal_target_total" ||
              activeHeadKey === "high_ideal_target_pt" ||
              activeHeadKey === "high_ideal_target_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "high",
                allFilters.selecteRPType?.value === "pt"
                  ? "ideal_target_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "ideal_target_regular"
                  : "ideal_target_total"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-up-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
              />
            </svg>
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "low_ideal_target_total" ||
              activeHeadKey === "low_ideal_target_pt" ||
              activeHeadKey === "low_ideal_target_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "low",
                allFilters.selecteRPType?.value === "pt"
                  ? "ideal_target_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "ideal_target_regular"
                  : "ideal_target_total"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-down-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
              />
            </svg>
          </span>
        </div>
      ),
      formatter: (_, row) => {
        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0",
            }}
          >
            <span
              className="tb-data"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                rowGap: "7px",
              }}
            >
              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "regular" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "overall"
                    ? "Overall:"
                    : null}{" "}
                  <b style={{ color: "rgb(205, 9, 9)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.ideal_target_total || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "regular"
                    ? "Regular:"
                    : null}{" "}
                  <b style={{ color: "rgb(0, 178, 149)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.ideal_target_regular || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "regular" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "pt"
                    ? "PT:"
                    : null}{" "}
                  <b style={{ color: "rgb(6, 108, 227)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.ideal_target_pt || 0)}
                  </b>
                </small>
              ) : null}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "deficit_total",
      text: (
        <div className="tb-head-row">
          <span>
            {`deficit ${allFilters.selecteRPType?.label || ""} amount`}
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "high_deficit_total" ||
              activeHeadKey === "high_deficit_pt" ||
              activeHeadKey === "high_deficit_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "high",
                allFilters.selecteRPType?.value === "pt"
                  ? "deficit_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "deficit_regular"
                  : "deficit_total"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-up-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
              />
            </svg>
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "low_deficit_total" ||
              activeHeadKey === "low_deficit_pt" ||
              activeHeadKey === "low_deficit_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "low",
                allFilters.selecteRPType?.value === "pt"
                  ? "deficit_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "deficit_regular"
                  : "deficit_total"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-down-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
              />
            </svg>
          </span>
        </div>
      ),
      formatter: (_, row) => {
        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0",
            }}
          >
            <span
              className="tb-data"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                rowGap: "7px",
              }}
            >
              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "regular" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "overall"
                    ? "Overall:"
                    : null}{" "}
                  <b style={{ color: "rgb(205, 9, 9)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.deficit_total || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "regular"
                    ? "Regular:"
                    : null}{" "}
                  <b style={{ color: "rgb(0, 178, 149)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.deficit_regular || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "regular" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "pt"
                    ? "PT:"
                    : null}{" "}
                  <b style={{ color: "rgb(6, 108, 227)", fontSize: "17px" }}>
                    ₹{formatNumber(row?.deficit_pt || 0)}
                  </b>
                </small>
              ) : null}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "target_acheived",
      text: (
        <div className="tb-head-row">
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0px",
            }}
          >
            <span>Today's {allFilters.selecteRPType?.label || ""} Target</span>
            <small>{TODAYS_DATE_FORMATTED}</small>
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "high_today_target" ||
              activeHeadKey === "high_today_target_pt" ||
              activeHeadKey === "high_today_target_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "high",
                allFilters.selecteRPType?.value === "pt"
                  ? "today_target_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "today_target_regular"
                  : "today_target"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-up-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
              />
            </svg>
          </span>
          <span
            className={`head-icon ${
              activeHeadKey === "low_today_target" ||
              activeHeadKey === "low_today_target_pt" ||
              activeHeadKey === "low_today_target_regular"
                ? "active"
                : ""
            }`}
            onClick={() =>
              sortedTableDataAccordingToKey(
                "low",
                allFilters.selecteRPType?.value === "pt"
                  ? "today_target_pt"
                  : allFilters.selecteRPType?.value === "regular"
                  ? "today_target_regular"
                  : "today_target"
              )
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-down-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
              />
            </svg>
          </span>
        </div>
      ),
      formatter: (_, row) => {
        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0",
            }}
          >
            <span
              className="tb-data"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                rowGap: "7px",
              }}
            >
              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "regular" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "overall"
                    ? "Overall:"
                    : null}{" "}
                  <b style={{ color: "rgb(205, 9, 9)" }}>
                    ₹{formatNumber(row?.today_target || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "pt" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "regular"
                    ? "Regular:"
                    : null}{" "}
                  <b style={{ color: "rgb(0, 178, 149)" }}>
                    ₹{formatNumber(row?.today_target_regular || 0)}
                  </b>
                </small>
              ) : null}

              {allFilters.selecteRPType?.value !== "regular" &&
              allFilters.selecteRPType?.value !== "overall" ? (
                <small>
                  {!allFilters.selecteRPType ||
                  allFilters.selecteRPType?.value !== "pt"
                    ? "PT:"
                    : null}{" "}
                  <b style={{ color: "rgb(6, 108, 227)" }}>
                    ₹{formatNumber(row?.today_target_pt || 0)}
                  </b>
                </small>
              ) : null}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose title={" "} onClose={onCloseModal} />

          <AgentwiseDailyTagrget
            userInfoData={user}
            prevAllFilters={allFilters}
            rowData={clickValues.rowData}
          />
        </div>
      </Modal>

      <CommonFilterStructure
        from="daily-target"
        decryptedText={user}
        setFilters={setAllFilters}
        filters={allFilters}
        onClickReset={onClickReset}
        targetStats={tbDatas.allStatsDta}
        filterType={allFilters.selecteRPType?.value}
        isReload={() => getDailyTargetData(tbFilters)}
      />

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
          <PaymentLinkTable
            tableData={
              tbDatas.sortedData?.length > 0
                ? tbDatas.sortedData
                : tbDatas.allData
            }
            tableColumns={tbColumns}
            isFirstColSticky={true}
          />
        </div>
      )}
    </>
  );
};

export default DailyTarget;
